export const env = {
  VUE_APP_API: window.config.AU,
  VUE_APP_APIKEY: window.config.AK,
  VUE_APP_IMG_LINK_SAVE: window.config.ILS,
  VUE_APP_IMG_LINK_PUBLISH: window.config.ILP,
  VUE_APP_MAX_HOME_SERVICES: window.config.MHS,
  VUE_APP_MAX_SERVICES: window.config.MS,
  VUE_APP_IMG_LINK_SERVICE_DEFAULT: window.config.ILSD,
  IMAGE_CDN_HOST: (window.config.CDN || '').replace(/\/$/, ''),
  DEV_USER_ID: window.config.UI,
  DEV_DOMAIN: window.config.D,
}

const GCS_HOST = 'https://storage.googleapis.com'

/** Reescribe una URL de GCS al CDN solo al pintar. No muta el valor guardado. */
export function toCdnImageUrl(url) {
  if (!url || typeof url !== 'string') return url
  const cdnHost = env.IMAGE_CDN_HOST
  if (!cdnHost) return url
  if (url.startsWith(`${cdnHost}/`)) return url
  if (!url.startsWith(`${GCS_HOST}/`)) return url
  return `${cdnHost}${url.slice(GCS_HOST.length)}`
}